"use client";

import { useMapUrlSync } from "@/hooks/use-map-url-sync";

interface InitialCoordinateSyncProps {
	backendMapCenter?: { lat: number; lng: number } | null;
	coordinates?: { lat: number; lng: number } | null;
}

/**
 * Client component that handles initial coordinate URL synchronization
 * Task 1: Add coordinates to URL on initial load using backendMapCenter
 */
export function InitialCoordinateSync({ backendMapCenter, coordinates }: InitialCoordinateSyncProps) {
	// Only handle initial coordinate sync - other scenarios handled in Apply Filters
	useMapUrlSync({ backendMapCenter, coordinates });

	// This component doesn't render anything - it's just for the hook side effect
	return null;
}
